const BinanceCnt = {
  symbol: "BNB",
  name: "binance",
  meta: {
    title: "Buy Binance Coin | Buy Binance Coin | Price and chart BNB",
    description:
      "binance Quinn (BNB) is the popular cryptocurrency of binance exchange, which has been able to find a good position with the support of this exchange. Quinn Nick Market provides the Quinnens Bins Quinn trading platform with a secure and fast platform.",
    keywords:
      "Binance Coin, Buy Binance Coin, Buy Binance Coin, Price Binance Coin, BNB",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه بایننس کوین بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید بایننس کوین کنید. خرید بایننس کوین در کوین نیک مارکت امن و آسان است. ",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول بایننس کوین کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " برخی از کیف پول‌های بایننس کوین که خود صرافی بایننس معرفی کرده است عبارتند از: تراست والت (Trust Wallet)، لجر والت (Ledger Wallet)، انجین والت (Enjin Wallet)، کوینومی (Coinomi)، اینفینیتو والت (Infinito Wallet)، مگنوم والت (Magnum wallet) و هو والت (Hoo Wallet).",
        },
      },
      {
        "@type": "Question",
        name: " آیا می‌توان بایننس کوین را در کوین نیک مارکت نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا بایننس کوین ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " بسیاری از سرمایه‌گذاران ارز دیجیتال معتقدند بایننس کوین یک سرمایه‌گذاری خوب و ایمن است. البته هیچ‌کس به‌طور قطعی نمی‌تواند درباره آینده نظر بدهد. این رمز ارز در درجه اول برای پرداخت کارمزد در صرافی ارز دیجیتال بایننس کاربرد دارد؛ این یک روش بسیار هوشمندانه برای بازگرداندن تریدرها به سیستم بایننس است و بایننس کوین را می‌توان مانند یک کوپن تخفیف در نظر گرفت. ارزش این کوین توسط صرافی بایننس پشتیبانی می‌شود. اگر اخباری در مورد صرافی بایننس یا چانگ پنگ ژائو ملقب به CZ، بنیانگذار اصلی این صرافی، منتشر شود، می‌تواند بر ارزش بایننس کوین تأثیر بگذارد.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Binance Quinn?",
      answer:
        "In Quinnic Market trading platform, you can buy Binance Coin with Shetab member bank card and the lowest fee. Buying Binance Coin at Coin Nick Market is safe and easy.",
      id: "toggler1",
    },
    {
      question: "What is the best Binance Quinn wallet?",
      answer:
        "Some of the binance Quinn wallets that binance Exchange has introduced are:Trust Wallet, Ledger Wallet, Enjin Wallet, Coinomi, Infinito Wallet, Magnum wallet and Hoo Wallet",
      id: "toggler2",
    },
    {
      question: "Is it possible to keep a coin bin in a niche market?",
      answer: "Keep_binance_description",
      id: "toggler3",
    },
    {
      question: "Is Binance Quinn worth the investment?",
      answer: "binance_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Binance",
        subTitle: "What is Binance Coin?",
        content: "Binance_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Binance Quinn",
        content: "Binance_history_description",
        btnTitle: "Buy and sell Binance Coin",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Binance buying and selling without intermediaries in coinnik Market",
        subTitle: "Buy Binance Coin",
        content: "Buy_binance_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sale Binance Coin",
        content: "sale_binance_description",
        btnTitle: "Buy and sell Binance Coin",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  blogTitle: "The latest binance analysis on the blog",
  informationTitle: "binance market statistics and information",
};

export default BinanceCnt;
